import React from 'react';

export default function Privacy() {
  return (
    <div className="bg-black pt-40 pb-32">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl md:text-7xl font-serif font-bold mb-16 text-white">Privacy Policy</h1>
        <div className="prose prose-invert prose-zinc max-w-none space-y-10 text-zinc-400">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">1. Commitment to Privacy</h2>
            <p>Maxmark Agency ("we", "us", or "our") is committed to protecting the privacy of our clients and visitors. This policy outlines how we handle personal information gathered through our website and intelligence services.</p>
          </section>
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">2. Information Collection</h2>
            <p>We collect information provided voluntarily through our contact and review request forms, including names, contact details, and business information. We also capture marketing attribution data (UTM parameters) to improve our outreach.</p>
          </section>
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-6">3. Use of Intelligence Data</h2>
            <p>Any competitor data monitored as part of our Intelligence Services is public-facing information. Maxmark does not access private accounts or confidential data of third parties.</p>
          </section>
          <p className="text-sm italic pt-10 border-t border-zinc-900">Last updated: January 2025.</p>
        </div>
      </div>
    </div>
  );
}